export default "__VITE_ASSET__00d82279__"